import { render, staticRenderFns } from "./tinymce-editor.vue?vue&type=template&id=856fd9a8&"
import script from "./tinymce-editor.vue?vue&type=script&lang=js&"
export * from "./tinymce-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports